require("../../scss/app-decks.scss");

import Application from "./application";

import Glide, { Autoplay, Breakpoints, Controls, Swipe } from "@glidejs/glide/dist/glide.modular.esm";
import HideShowBehaviour from "../behaviours/hide-show-behaviour";
import StickyNavBehaviour from "../behaviours/sticky-nav-behaviour";
import MobileMenuBehavior from "../behaviours/mobile-menu-behaviour";
import ToggleClassBehavior from "../behaviours/toggle-class-behaviour";
import ReadMoreBehaviour from "../behaviours/read-more-behaviour";
import CarouselBehaviour from "../behaviours/carousel-behaviour";

import Gallery from "../jsx/gallery";
import ShortlistCount from "../jsx/shortlist/shortlist-count";
import ShortlistButton from "../jsx/shortlist/shortlist-button";
import VideoModal from "../jsx/modal/video-modal";
import VirtualTourModal from "../jsx/modal/virtual-tour-modal";
import ImageModal from "../jsx/modal/image-modal";

import TabsBehaviour from "../behaviours/tabs-behaviour";
import BlockEventBehaviour from "../behaviours/block-event-behaviour";


let config = {};
config.behaviours = {
  'HideShowBehaviour': new HideShowBehaviour(),
  'StickyNavBehaviour': new StickyNavBehaviour(),
  'MobileMenuBehaviour': new MobileMenuBehavior(),
  'ToggleClassBehaviour': new ToggleClassBehavior(),
  'ReadMoreBehaviour': new ReadMoreBehaviour(),
  'TabsBehaviour': new TabsBehaviour(),
  'CarouselBehaviour': new CarouselBehaviour(),
  'BlockEventBehaviour': new BlockEventBehaviour()
};
config.components = {
    'gallery': Gallery,
    'shortlist-count': ShortlistCount,
    'shortlist-button': ShortlistButton,
    'video-modal': VideoModal,
    'virtual-tour-modal': VirtualTourModal,
    'image-modal': ImageModal,
};

new Application(config);

window.loadDeckPlanJs = function(){
  window.glide = {};
  document.addEventListener('hideShowBehaviourOpen', e =>  {
    if (e.detail === document.querySelector('#key-modal')) window.lazy.update()
  });

  let glideEl = document.querySelector('.deck-slider')
  if (glideEl) {
    let startAt = glideEl.getAttribute('data-glide-start');
    window.glide.deckSlider = new Glide(glideEl, {
      type: 'slider',
      autoplay: false,
      perView: 1,
      gap: 0,
      bound: true,
      startAt: startAt,
      focusAt: 'center',
      animationDuration: 0,
      rewindDuration: 0,
      dragThreshold: false,
      breakpoints: {
        992: {
          dragThreshold: 120
        }
      }
    });

    const nextButtons = [...document.querySelectorAll('[data-glide-next]')];
    const prevButtons = [...document.querySelectorAll('[data-glide-prev]')];

    nextButtons.map(nextBtn => {
      nextBtn.addEventListener('click', e => {
        e.preventDefault();
        window.glide.deckSlider.go('>');
        window.dataAttrBehaviours.CarouselBehaviour.refresh();
        window.lazy.update();
      });
    });
    prevButtons.map(prevButton => {
      prevButton.addEventListener('click', e => {
        e.preventDefault();
        window.glide.deckSlider.go('<');
        window.dataAttrBehaviours.CarouselBehaviour.refresh();
        window.lazy.update()
      });
    });

    window.glide.deckSlider.on('run.after', e => {
      const slides = document.querySelectorAll('.glide__slide');
      const currentSlide = slides[window.glide.deckSlider.index];
      const targetDeck = currentSlide.dataset.deck;
      const key = currentSlide.dataset.deckTitle;

      [...document.querySelectorAll('.deck-plan--deck')].map(deck => deck.classList.remove('d-block'));
      document.getElementById(targetDeck).classList.add('d-block');

      [...document.querySelectorAll('.deck-plan--nav .deck-plan--nav-link, .deck-plan--nav-modal p')].map(navItem => navItem.classList.remove('active'));
      [...document.querySelectorAll(`[data-deck="${targetDeck}"]`)].map(target => target.classList.add('active'));

      // update mobile navigation key
      document.querySelector('#navigation-key').innerText = key;
    });
    [...document.querySelectorAll(`[data-deck-index]`)].map(navItem => {
      navItem.addEventListener('click', e => {
        e.preventDefault();

        [...document.querySelectorAll(`[data-deck-index]`)].map(deckIndex => deckIndex.classList.remove('active'));
        e.target.classList.add('active');
        window.glide.deckSlider.go(e.target.dataset.deckIndex);
        window.lazy.update();
        window.dataAttrBehaviours.CarouselBehaviour.refresh();
      });
    });
    window.addEventListener('load', e => {
      window.glide.deckSlider.mount({ Controls, Swipe });
      window.dataAttrBehaviours.CarouselBehaviour.refresh();
    });
  }
};

document.readyState !== "loading" ? window.loadDeckPlanJs() : document.addEventListener("DOMContentLoaded",  window.loadDeckPlanJs);